import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _defineProperty from "/usr/src/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/** @jsxImportSource @emotion/react */
import { useRouter } from "next/router";
import { Typography } from "@vc-workspace/utils-typography";
import Dialog from '@mui/material/Dialog';
import { useState } from "react";
import { UtilsStickyBottomCta } from '@vc-workspace/utils-sticky-bottom-cta';
import { filterTypeContainer, filterItem, activeFilterItem, filterListContainer } from './filter-modal-dialog.module.style';
import { FilterTypes } from "@vc-workspace/utils-constants";
import { UtilsSeparator } from "@vc-workspace/utils-separator";
import PriceRangeFilter from '../price-range-filter/price-range-filter';
import DiscountFilter from '../discount-filter/discount-filter';
import CategoryFilters from '../category-filters/category-filters';
/* eslint-disable-next-line */

export function FilterModalDialog(props) {
  var router = useRouter();
  var priceFilters = []; //props.filters.filter(item => item.filterType === FilterTypes.Price);

  var discountFilters = []; //props.filters.filter(item => item.filterType === FilterTypes.Discount);

  var categoryFilters = props.filters.filter(function (item) {
    return item.filterType === FilterTypes.Category;
  });

  var _useState = useState(false),
      isOpen = _useState[0],
      setOpen = _useState[1];

  var _useState2 = useState(categoryFilters.length ? 'category' : priceFilters.length ? 'price' : 'discount'),
      activeFilterView = _useState2[0],
      setActiveFilterView = _useState2[1];

  var _useState3 = useState({}),
      appliedFilters = _useState3[0],
      setAppliedFilter = _useState3[1];

  if (!props.filters.length) {
    return null;
  }

  function onFilterSelect(query) {
    setAppliedFilter(_objectSpread(_objectSpread({}, appliedFilters), query));
  }

  function onApplyFilters() {
    setOpen(false);
    router.push({
      pathname: props.context.pathname,
      query: _objectSpread(_objectSpread({}, props.context.query), appliedFilters)
    });
  }

  return _jsxs(_Fragment, {
    children: [_jsxs(Typography, {
      type: "SubHeading1",
      color: "dim_grey",
      onClick: function onClick() {
        return setOpen(true);
      },
      semi_bold: true,
      children: [_jsx("img", {
        src: "/_mp-images/ic_filter.png",
        className: "inline-block w-5"
      }), _jsx("span", {
        className: "align-middle pl-2",
        children: "Filter"
      })]
    }), _jsxs(Dialog, {
      open: isOpen,
      onClose: function onClose() {
        return setOpen(false);
      },
      fullScreen: true,
      children: [_jsxs("div", {
        className: "pure-g h-full",
        children: [_jsxs("div", {
          className: "pure-u-1-3",
          css: filterTypeContainer,
          children: [categoryFilters.length ? _jsxs(_Fragment, {
            children: [_jsx(Typography, {
              type: "SubHeading1",
              color: activeFilterView === "category" ? "black" : "dim_grey",
              custom_style: [filterItem, activeFilterView === 'category' ? activeFilterItem : null],
              onClick: function onClick() {
                return setActiveFilterView('category');
              },
              bold: activeFilterView === 'category',
              children: "Category"
            }), _jsx(UtilsSeparator, {
              color: "gainsboro",
              spacingTop: "0px",
              spacingBottom: "0px"
            })]
          }) : null, priceFilters.length ? _jsxs(_Fragment, {
            children: [_jsx(Typography, {
              type: "SubHeading1",
              color: activeFilterView === "price" ? "black" : "dim_grey",
              custom_style: [filterItem, activeFilterView === 'price' ? activeFilterItem : null],
              onClick: function onClick() {
                return setActiveFilterView('price');
              },
              bold: activeFilterView === 'price',
              children: "Price Range"
            }), _jsx(UtilsSeparator, {
              color: "gainsboro",
              spacingTop: "0px",
              spacingBottom: "0px"
            })]
          }) : null, discountFilters.length ? _jsxs(_Fragment, {
            children: [_jsx(Typography, {
              type: "SubHeading1",
              color: activeFilterView === "discount" ? "black" : "dim_grey",
              custom_style: [filterItem, activeFilterView === 'discount' ? activeFilterItem : null],
              onClick: function onClick() {
                return setActiveFilterView('discount');
              },
              bold: activeFilterView === 'discount',
              children: "Discount"
            }), _jsx(UtilsSeparator, {
              color: "gainsboro",
              spacingTop: "0px",
              spacingBottom: "0px"
            })]
          }) : null]
        }), _jsx("div", {
          className: "pure-u-2-3 pt-4",
          children: _jsxs("div", {
            css: filterListContainer,
            children: [activeFilterView === "category" && !props.customCategoryFilter ? _jsx(CategoryFilters, {
              context: props.context,
              filterDetails: props.filters.filter(function (item) {
                return item.filterType === FilterTypes.Category;
              })[0],
              onFilterSelect: onFilterSelect,
              withoutHeading: true,
              preventNavigation: true
            }) : null, activeFilterView === "category" && props.customCategoryFilter ? _jsx(_Fragment, {
              children: props.customCategoryFilter
            }) : null, activeFilterView === "price" ? _jsx(PriceRangeFilter, {
              context: props.context,
              filterDetails: props.filters.filter(function (item) {
                return item.filterType === FilterTypes.Price;
              })[0],
              onFilterSelect: onFilterSelect,
              withoutHeading: true,
              preventNavigation: true
            }) : null, activeFilterView === "discount" ? _jsx(DiscountFilter, {
              context: props.context,
              filterDetails: props.filters.filter(function (item) {
                return item.filterType === FilterTypes.Discount;
              })[0],
              onFilterSelect: onFilterSelect,
              withoutHeading: true,
              preventNavigation: true
            }) : null]
          })
        })]
      }), _jsxs(UtilsStickyBottomCta, {
        className: "w-full",
        children: [_jsx(Typography, {
          type: "SubHeading1",
          color: "heavy_metal",
          onClick: function onClick() {
            return setOpen(false);
          },
          semi_bold: true,
          children: "CLOSE"
        }), _jsx(Typography, {
          type: "SubHeading1",
          color: "purple_heart",
          onClick: onApplyFilters,
          semi_bold: true,
          children: "APPLY"
        })]
      })]
    })]
  });
}
export default FilterModalDialog;